import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import { showToast } from "../../utils/isValidImage";
import { createNotification, updateNotification } from "../../api/notification";
const countriesList = ["IN", "Rest of the world"];

const CreateNotificationModal = ({ show, handleClose, fetchdata, cardDetail, cardId }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title: "",
    // week_count: "",
    content: "",
    status: [],
    nosignedup: false,
    repeat: null,
    // setTime: "",
    // date: "",
    trigger_time:"",
    mode: "",
    demographic: [],
    country: [],
    dynamic_inputs: [""],
  });

  useEffect(() => {
    if (cardDetail) {
      setForm({
        title: cardDetail.title || "",
        // week_count: Number(cardDetail.week_count || ""),
        content: cardDetail.content || "",
        status: cardDetail.status || [],
        nosignedup: cardDetail.nosignedup || false,
        repeat: cardDetail.repeat || null,
        // setTime: cardDetail.setTime || "",
        // date: cardDetail.date || "",
        trigger_time: cardDetail.trigger_time || "",
        mode: cardDetail.mode || "",
        demographic: cardDetail.demographic || [],
        country: cardDetail.country || [],
        dynamic_inputs: cardDetail.dynamic_inputs?.length ? cardDetail.dynamic_inputs : [""],
      });
    }
  }, [cardDetail]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      const updatedList = checked
        ? [...form[name], value]
        : form[name].filter((item) => item !== value);
      setForm({ ...form, [name]: updatedList });
    } else {
      setForm({ ...form, [name]: type === "checkbox" ? checked : value });
    }
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
      setForm({ ...form, [name]: checked ? 'repeat_everyday' : null });
  };

  const handleInputChange = (index, e) => {
    const updated = [...form.dynamic_inputs];
    updated[index] = e.target.value;
    setForm({ ...form, dynamic_inputs: updated });
  };

  const handleAddInput = () => {
    setForm({ ...form, dynamic_inputs: [...form.dynamic_inputs, ""] });
  };

  const handleRemoveInput = (index) => {
    if (form.dynamic_inputs.length > 1) {
      const updated = form.dynamic_inputs.filter((_, i) => i !== index);
      setForm({ ...form, dynamic_inputs: updated });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      
      let payload = { ...form,
        // week_count : Number(form.week_count)
        
       };

      const response = cardId
        ? await updateNotification(cardId, payload)
        : await createNotification(payload);
      fetchdata(response.data.data);
      showToast("Notification Created successfully", true);
      handleClose();
    } catch (err) {
      console.log(err)
      showToast(err.response?.data?.message?.[0] || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const formatToDatetimeLocal = (date) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };
  

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{cardId ? "Update" : "Create New"} Notification</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="p-4 bg-light border rounded" onSubmit={handleSubmit}>
          <Row>
            {/* Left Column */}
            <Col md={6}>
              <Form.Group controlId="title">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group controlId="content" className="mt-3">
                <Form.Label>Content</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={10}
                  name="content"
                  value={form.content}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label><strong>Repeat</strong></Form.Label>
                <div>
                  {["repeat_everyday"].map((val) => (
                    <Form.Check
                      inline
                      key={val}
                      label={val.replace("_", " ").toUpperCase()}
                      type="checkbox"
                      name="repeat"
                      value={val}
                      checked={form.repeat === val}
                      onChange={handleCheckboxChange}
                    />
                  ))}
                </div>
              </Form.Group>

              {/* <Form.Group controlId="week_count" className="mt-3">
                <Form.Label>Week Count</Form.Label>
                <Form.Control
                  type="number"
                  name="week_count"
                  value={form.week_count}
                  onChange={handleChange}
                />
              </Form.Group> */}
            </Col>

            {/* Right Column */}
            <Col md={6}>
              <Form.Group className="mt-0">
                <Form.Label column sm={12}><strong>Status</strong></Form.Label>
                {["subscribed", "unsubscribed", "nosignedup"].map((val) => (
                  <Form.Check
                    key={val}
                    type="checkbox"
                    label={val.charAt(0).toUpperCase() + val.slice(1)}
                    name="status"
                    value={val}
                    checked={form.status.includes(val)}
                    onChange={handleChange}
                    inline
                  />
                ))}
              </Form.Group>

              <Row className="mt-3">
                {/* <Col md={6}>
                  <Form.Label>Set Time</Form.Label>
                  <Form.Control
                    type="time"
                    name="setTime"
                    value={form.setTime}
                    onChange={handleChange}
                  />
                </Col>
                <Col md={6}>
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    name="date"
                    value={form.date}
                    onChange={handleChange}
                  />
                </Col> */}

                <Col md={12}>
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="trigger_time"
                    value={formatToDatetimeLocal(new Date(form.trigger_time))}
                    onChange={handleChange}
                  />
                </Col>

              </Row>

              <Form.Group className="mt-3">
                <Form.Label><strong>Demographic</strong></Form.Label>
                <div>
                {["male", "female"].map((val) => (
                 
                  <Form.Check
                    inline
                    key={val}
                    label={val.charAt(0).toUpperCase() + val.slice(1)}
                    type="checkbox"
                    name="demographic"
                    value={val}
                    checked={form.demographic.includes(val)}
                    onChange={handleChange}
                  />
                 
                ))}
                 </div>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label><strong>Country</strong></Form.Label>
                <Row>
                  {countriesList.map((country) => (
                    <Col xs={6} key={country}>
                      <Form.Check
                        type="checkbox"
                        label={country === 'IN' ? 'India' : country}
                        name="country"
                        value={country}
                        checked={form.country.includes(country)}
                        onChange={handleChange}
                      />
                    </Col>
                  ))}
                </Row>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label><strong>Type</strong></Form.Label>
                <div>
                <Form.Check
                  inline
                  label="Static"
                  type="radio"
                  name="mode"
                  value="static"
                  checked={form.mode === "static"}
                  onChange={handleChange}
                />
                <Form.Check
                  inline
                  label="Dynamic"
                  type="radio"
                  name="mode"
                  value="dynamic"
                  checked={form.mode === "dynamic"}
                  onChange={handleChange}
                />
                </div>
              </Form.Group>

              {/* Dynamic Inputs */}
              {form.mode === "dynamic" &&
                form.dynamic_inputs.map((input, index) => (
                  <Form.Group key={index} className="mb-3">
                    <div className="d-flex">
                      <Form.Control
                        type="text"
                        value={input}
                        placeholder={`Input ${index + 1}`}
                        onChange={(e) => handleInputChange(index, e)}
                        required
                      />
                      {form.dynamic_inputs.length > 1 && (
                        <Button
                          variant="danger"
                          className="ms-2"
                          type="button"
                          onClick={() => handleRemoveInput(index)}
                        >-</Button>
                      )}
                      {index === form.dynamic_inputs.length - 1 && (
                        <Button
                          variant="primary"
                          className="ms-2"
                          type="button"
                          onClick={handleAddInput}
                        >+</Button>
                      )}
                    </div>
                  </Form.Group>
                ))}
            </Col>
          </Row>

          <div className="d-flex justify-content-between mt-4">
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? "Submitting..." : cardId ? "Update" : "Add"}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateNotificationModal;
